module.exports = __webpack_public_path__ + "img/md.e2da852d.svg";